import React from "react";
import { Input } from "reactstrap";
import Select from "react-select";

import {
  TableEditContainer,
  Table,
  Header,
  Row,
  Data
} from "./tableComponents";


export const TableEdit = ({
  tableName,
  headers,
  items,
  onChange,
  initialValues,
}) => (
  <TableEditContainer>
    <Table>
      <thead>
        <tr>
          {Object.keys(headers).map((id) => (
            <Header key={id}>
              <h5>{headers[id].label}</h5>
            </Header>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.map(({ __typename, ...item }) => (
          <Row key={item.id}>
            {
              Object.keys(item).map((key) => {
                const header = headers[key];
                const label = typeof item[key] === "object" ? item[key].label : item[key];
                const originalItem = initialValues.find(elem => elem.id === item.id);
                const originalValue = typeof originalItem[key] === "object" ? originalItem[key].value : originalItem[key];

                return (
                  <Data key={`${tableName}-${item.id}-${key}`}>
                    {key !== "action" && header.isEditable && (originalValue === null || originalValue === undefined) ? (
                      <React.Fragment>
                        {header.component === "select" && (
                          <Select
                            styles={{ valueContainer: () => ({ width: 200 }) }}
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="itemSelected"
                            value={item[key]}
                            onChange={(valueChange) => onChange({ newValue: valueChange, id: item.id, key })}
                            options={[
                              {
                                value: "",
                                isDisabled: true,
                              },
                              ...(Array.isArray(header.options)
                                ? header.options
                                : header.options[item[key].optionKey] || []),
                            ]}
                            placeholder=""
                          />
                        )}
                        {header.component === "text" && (
                          <Input
                            value={label}
                            onChange={(e) => {
                              const { newValue } = e.target;
                              if (!header.isValid || header.isValid(newValue)) {
                                onChange({ newValue, id: item.id, key });
                              }
                            }}
                            style={{
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              backgroundColor: "transparent",
                              padding: "2px 4px",
                              outline: "none",
                            }}
                          />
                        )}
                      </React.Fragment>
                    ) : (
                      (header && header.formatter ? header.formatter(label) : label)
                    )}
                  </Data>
                );
              })
            }
          </Row>
        ))}
      </tbody>
    </Table>
  </TableEditContainer>
);
